<template>
  <div>
    <div class="container" style="min-height: 768px; margin-top: 20px">
      <div class="col-md-3">
        <div class="subNavBox">
          <div class="navTitle">{{$Lang.L({cn:'解决方案',hk:'',en:'Solution'})}}</div>
          <lfmenu
          class="leftNavMenu"
            :items="delist"
            :level="10"
            v-model="currId"
            :target="{ that: this }"
            style="margin-bottom: 0px"
          ></lfmenu>
        </div>
      </div>
      <div class="col-md-9">
        <div class="articleTop">
          <div class="row">
            <div class="col-md-6" style="font-size: 16px">
              {{$Lang.L({cn:content.displayName,hk:'',en:content.displayNameEn})}}
            </div>
            <div class="col-md-6">{{ content.remark }}</div>
            <div class="articleBrakeLine" style="margin-top: 10px"></div>
          </div>
          <div class="main-content" id="Substance" style="margin-top: 20px;overflow-x:hidden">
            <div class="imgbox" style="text-align: center">
              <img :src="$util.fixProtocol(content.targetUrl)" style="max-width:300px;"/>
            </div>
            <div class="" v-html="$Lang.L({cn:content.substance,en:content.substanceEn,hk:''})"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import common from "../webapi/common.js";
import "../assets/css/lfmenu.css";
import lfmenu from "../components/lfmenu.vue";
export default {
  components: { lfmenu },
  data() {
    return {
      delist: [],
      content: {
        targetUrl: "",
          displayNameCN: "",
          displayNameEN: "",
          remark: "",
          substance: "",
          substanceEn: "",
        webSortDisplayName: "",
      },
      currId: 0,
      currItem: {},
    };
  },
  watch: {
    delist: {
      deep: true,
      handler: function () {
        this.delist.forEach((item) => {
          this.findActive(item);
        });
        this.$ajax
          .get(common.webapi.getWebSolution + this.currItem.id/100)
          .then((res) => {
            this.content = res.data.data;
            this.content.displayNameCN=res.data.data.displayName
            this.content.displayNameEN=res.data.data.displayNameEn
          });
        // console.log(this.delist);
      },
    },
  },
  async mounted() {
    // debugger;
     this.$route.query.id ? (this.$data.currId = this.$route.query.id) : "";
    this.$parent.currPage=3
    this.$ajax.get(common.webapi.getWebSolutionSort).then((res) => {
      var curr = 0;
      let arr=res.data.data[0].children
      this.delist = [];
      arr.forEach((ele) => {
        this.loopChild(ele, curr);
        curr++;
      });
       this.delist = arr;
    });
  },
  methods: {
    loopChild(item, count) {
      if (item.children) {
        if (item.children.length > 0) {
          item.children.forEach((ele) => {
            this.loopChild(ele, count++);
          });
        }
      } else {
        console.log(this.currId)
        if (this.$data.currId == 0) {
          if (this.$data.currId == count) {
            item.isCurr = true;
          } else {
            item.isCurr = false;
          }
        } else {
         
          if (this.$data.currId == item.id*100) {
            debugger
            item.isCurr = true;
          } else {
            item.isCurr = false;
          }
        }
      }
    },
    findActive(item) {
      if (item.children) {
        item.children.forEach((ele) => {
          this.findActive(ele);
        });
      } else {
        if (item.isCurr == true) {
          this.currItem = item;
        }
      }
    },
  },
};
</script>
<style scoped>
.articleTop {
  box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
  min-height: 768px;
  margin-bottom: 18px;
  padding: 12px;
  border-top: 2px solid #1a2f57;
}
.articleBrakeLine {
  border-bottom: 1px solid rgba(128, 128, 128, 0.15);
  padding: 10px;
}
</style>